// extracted by mini-css-extract-plugin
export default {"titlePages":"TitlePages_titlePages__ZuGNV"};